import React, { memo, useEffect } from "react";
import { FormspreeProvider } from "@formspree/react";

// Context
import { useAppContext } from "../../context/AppContext";

// Components
import Section1 from "./Section1";

export const intersectOptions = {
  threshold: window.innerWidth < 1024 ? 0 : 0.5,
  triggerOnce: true,
};

const PROJECT_ID = "1585356216819777387";

function Contact() {
  const { setHeaderClass } = useAppContext();
  useEffect(() => setHeaderClass(""));

  return (
    <FormspreeProvider project={PROJECT_ID}>
      <Section1 />
    </FormspreeProvider>
  );
}

export default memo(Contact);
